import type {
  CharterConfig,
  CharterSession,
  MemberPrepSession,
  TeamCharterStatus,
  UnassignedMember,
  RenegotiationRequest,
  CharterVersion,
} from '../types/charterTypes'

export interface CharterState {
  config: CharterConfig | null
  session: CharterSession | null
  myProfile: MemberPrepSession | null
  teamStatuses: TeamCharterStatus[]
  /** Students who have joined but have no team yet. */
  unassignedMembers: UnassignedMember[]
  teamProfiles: MemberPrepSession[]
  renegotiationRequest: RenegotiationRequest | null
  charterVersions: CharterVersion[]
  gateStatus: {
    gate_enabled: boolean
    gate_satisfied: boolean
    teams_total?: number
    teams_ratified?: number
  } | null
  isLoading: boolean
  /** Which room-wide Round 0 control action is currently in flight, if any. */
  roundControlLoading: string | null
  error: string | null
}

const charterInitialState: CharterState = {
  config: null,
  session: null,
  myProfile: null,
  teamStatuses: [],
  unassignedMembers: [],
  teamProfiles: [],
  renegotiationRequest: null,
  charterVersions: [],
  gateStatus: null,
  isLoading: false,
  roundControlLoading: null,
  error: null,
}

export default charterInitialState
